import { api } from '@/api';
import { createAsyncThunk } from '@/store/utils';
import type {
  ConsentsResponseDTO,
  CountriesResponseDTO,
  SalesPointConfigurationResponseDTO,
} from '@/types/dto/agent';
import type { TenantOption } from '@/types/tenant';
import { setTenantBrand, setTenantFavicon } from '@/utils/color';

export const setTenant = createAsyncThunk<TenantOption, TenantOption>(
  'configuration/setTenant',
  (tenant) => {
    setTenantBrand(tenant);
    setTenantFavicon(tenant);

    return tenant;
  }
);

export const getSalesPointConfiguration =
  createAsyncThunk<SalesPointConfigurationResponseDTO>(
    'configuration/getSalesPointConfiguration',
    async () => {
      return (
        await api.agentApi.PointOfSaleConfiguration_GetSalesPointConfiguration()
      ).data;
    }
  );

export const getConsents = createAsyncThunk<ConsentsResponseDTO>(
  'configuration/getConsents',
  async () => {
    return (await api.agentApi.Consents_GetConsents()).data;
  }
);

export const getCountries = createAsyncThunk<CountriesResponseDTO>(
  'configuration/getCountries',
  async () => {
    return (await api.agentApi.Country_GetCountries()).data;
  }
);
